module.exports = __webpack_public_path__ + "static/media/signup.e1b2c010.jpg";